import { defineAsyncComponent } from "vue";

import { captureMessageWithContext } from "@/sentry";

export function lazy(loader) {
  return defineAsyncComponent(() => loader().catch(reloadOnMissingChunks));
}

// For ROUTE components only. Vue Router resolves a bare loader function during navigation
// and reads the real component's in-component guards (beforeRouteLeave/beforeRouteUpdate) —
// which it can't extract through a defineAsyncComponent wrapper (see lazy()). Use this for
// route `component:` entries; use lazy() for in-template <component :is> async components.
export function lazyRoute(loader) {
  return () => loader().catch(reloadOnMissingChunks);
}

function reloadOnMissingChunks(error) {
  const isDynamicImportError =
    error instanceof TypeError &&
    (error.message.startsWith("Failed to fetch dynamically imported module") ||
      error.message.startsWith("error loading dynamically imported module"));

  if (
    error.name === "ChunkLoadError" ||
    error.code === "CSS_CHUNK_LOAD_FAILED" ||
    isDynamicImportError
  ) {
    window.location.reload();
    return {};
  }
  captureMessageWithContext("Failed loading a component with an unknown error", { error });
  throw error;
}
